import { Button } from 'primereact/button';
import { memo } from 'react';
import { copyToClipboard } from '../utils/copyToClipboard';

type ActionButtonsProps = {
  messageContent: string;
};

export const ActionButtons = memo(({ messageContent }: ActionButtonsProps) => (
  <div className="message-actions">
    <Button
      icon="pi pi-copy"
      className="p-button-text p-button-sm action-button"
      onClick={() => copyToClipboard(messageContent)}
      tooltip="Copy message text"
      tooltipOptions={{ position: 'top' }}
      text
    />
    <Button
      icon="pi pi-thumbs-up"
      className="p-button-text p-button-sm action-button"
      tooltip="Helpful"
      tooltipOptions={{ position: 'top' }}
      disabled
      text
    />
    <Button
      icon="pi pi-thumbs-down"
      className="p-button-text p-button-sm action-button"
      tooltip="Not helpful"
      tooltipOptions={{ position: 'top' }}
      disabled
      text
    />
  </div>
));
